import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';

import Input from '../../components/form/input';
import DragNDropFileupload from '../../components/form/dragNdropFileupload';

const initialState = {};

export function isValidEmail(input) {
    if (typeof input !== 'string') return false;
    const pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return pattern.test(input.trim());
}

@observer
class SendEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
            uploadedFiles: [],
            recipientEmail: props.users?.[0]?.email || '',
        };
    }

    getRecipients = () => {
        const { users = [], editableRecipient = false } = this.props;
        const { recipientEmail = '' } = this.state;
        return users.map((user, index) => ({
            ...user,
            email: `${editableRecipient && index === 0 ? recipientEmail : (user.email || '')}`.trim(),
        }));
    }

    onRecipientInput = e => {
        this.setState({
            recipientEmail: e.target.value,
            errorTmp: null,
        });
    }

    handleUploadedFile = (file) => {
        this.setState(prev => ({
            uploadedFiles: [...prev.uploadedFiles, file],
        }));
    }

    removeUploadedFile = (e) => {
        const url = e.target.closest('button').dataset.url;
        this.setState(prev => ({
            uploadedFiles: prev.uploadedFiles.filter(f => f.s3Link !== url),
        }));
    }

    sendEmail = async () => {
        this.setState({
            inProgress: true,
        });
        const { drawerLevel = 1, from, isPlainEmail = true, emailType = 'transactional' } = this.props;
        const { appState } = this.props.stores;
        const { newEmail = {} } = appState;
        const { uploadedFiles = [] } = this.state;
        const validRecipients = this.getRecipients().filter(u => isValidEmail(u.email));

        if (!newEmail.subject || !newEmail.body) {
            this.setState({
                errorTmp: 'Error! Please fill in all fields.',
                inProgress: false,
            });
            return;
        }

        if (validRecipients.length === 0) {
            this.setState({
                errorTmp: 'Error! Please enter a valid recipient email address.',
                inProgress: false,
            });
            return;
        }

        const attachmentUrls = uploadedFiles.map(f => f.s3Link);

        let response;
        if (isPlainEmail) {
            response = await appState.sendEmailPlain({
                // from: '',
                from,
                to: validRecipients.map(u => (
                    u.customerId ? { email: u.email, customerId: u.customerId } : u.email
                )),
                subject: newEmail.subject,
                body: newEmail.body,
                attachmentUrls,
                emailType,
            });
        } else {
            response = await appState.sendEmail({
                // from: '',
                from,
                to: validRecipients.map(u => (
                    u.customerId ? { email: u.email, customerId: u.customerId } : u.email
                )),
                subject: newEmail.subject,
                body: newEmail.body,
                attachmentUrls,
                emailType,
            });
        }


        if (response.status === 200) {
            appState.updateKeyValue('newEmail', {});
            this.setState({
                message: 'Email sent!',
                inProgress: false,
                uploadedFiles: [],
            });
            setTimeout(() => {
                appState.toggleDrawer(false, drawerLevel);
            }, 1000);
        } else {
            this.setState({
                error: 'Error! Could not send email. Please try again later.',
                inProgress: false,
            });
        }
    }

    componentDidMount() {
        const { appState } = this.props.stores;
        appState.updateKeyValue('newEmail', {
            subject: this.props.subject || '',
            body: this.props.body || '',
        });
    }

    render() {
        const { error, errorTmp, message, inProgress, uploadedFiles = [] } = this.state;
        const { from, emailType = 'transactional', editableRecipient = false } = this.props;
        const { appState } = this.props.stores;
        const { newEmail = {} } = appState;
        const users = this.getRecipients();
        const invalidUsers = users.filter(u => !isValidEmail(u.email));

        return (<>
            <div class='d-flex flex-column justify-content-start overflow-auto mb-5 mt-3 p-4'>
                <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                    <Text id='race.admin.send-email-title'>Send Email</Text>
                </div>

                {/* <xmp>{JSON.stringify(users, null, 4)}</xmp> */}
                <div class='d-flex flex-row justify-content-start px-2'>
                    {from && <>
                        <span class='me-2 text-muted'>
                            <Text id='input.from'>From</Text>
                        </span>
                        <span class={`badge text-bg-secondary font-weight-normal me-1 mt-1`}>
                            {from}
                        </span>
                    </>}
                </div>
                <div class='d-flex flex-wrap justify-content-start px-2'>
                    <span class='me-2 text-muted'>
                        <Text id='input.to'>To</Text>
                    </span>
                    {editableRecipient ? <Localizer>
                        <input
                            type='email'
                            class='form-control form-control-sm rounded-pill flex-fill'
                            value={this.state.recipientEmail}
                            placeholder={<Text id='input.email'>Email</Text>}
                            onInput={this.onRecipientInput}
                        />
                    </Localizer> : users.filter(u => isValidEmail(u.email)).map(user => {
                            return <span
                                key={user.customerId || user.email}
                                class={`badge text-bg-secondary font-weight-normal me-1 mt-1`}
                            >
                                {user.firstname} {user.lastname} &lt;{user.email}&gt;
                            </span>;
                        })}
                </div>
                {invalidUsers.length > 0 && <div class='d-flex flex-wrap justify-content-start px-2'>
                    <span class='me-2 text-muted'>
                        <Text id='input.invalid-emails'>Invalid emails</Text>
                    </span>
                    {invalidUsers.map(user => {
                        return <span
                            key={user.customerId || user.email}
                            class={`badge text-bg-danger font-weight-normal me-1 mt-1`}
                        >
                            {user.firstname} {user.lastname} &lt;{user.email}&gt;
                        </span>;
                    })}
                </div>}

                {emailType === 'newsletter' && <>
                    <div class='alert alert-warning mx-2 my-2' role='alert'>
                        <i class='fa-solid fa-circle-info me-2' />
                        <Text id='email.newsletter-info'>This is a newsletter. Unsubscribed recipients will be skipped and an unsubscribe link will be appended to the email.</Text>
                    </div>
                    {users.filter(u => isValidEmail(u.email) && u.newsletterUnsubscribed).length > 0 && <div class='d-flex flex-wrap justify-content-start px-2'>
                        <span class='me-2 text-body-secondary'>
                            <Text id='email.skipped-unsubscribed'>Skipped (unsubscribed)</Text>
                        </span>
                        {users.filter(u => isValidEmail(u.email) && u.newsletterUnsubscribed).map(user => (
                            <span
                                key={user.customerId || user.email}
                                class='badge text-bg-warning font-weight-normal me-1 mt-1'
                            >
                                {user.firstname} {user.lastname} &lt;{user.email}&gt;
                            </span>
                        ))}
                    </div>}
                </>}

                <Localizer>
                    <Input
                        classNames='form-control rounded-lg'
                        title={<Text id='input.subject'>Subject</Text>}
                        placeholder={<Text id='input.subject'>Subject</Text>}
                        stores={this.props.stores}
                        holdingStore={appState}
                        object={newEmail}
                        objectName={'newEmail'}
                        type={'text'}
                        field={'subject'}
                        extraDataset={{
                            'data-isnew': true,
                        }}
                    />
                </Localizer>
                <Localizer>
                    <Input
                        classNames='form-control rounded-lg'
                        title={<Text id='input.email-body'>Email content</Text>}
                        placeholder={<Text id='input.email-body'>Email content</Text>}
                        help={<Text id='input.email-body-help'>Your email content.</Text>}
                        stores={this.props.stores}
                        holdingStore={appState}
                        object={newEmail}
                        objectName={'newEmail'}
                        type={'textarea'}
                        field={'body'}
                        extraDataset={{
                            'data-isnew': true,
                        }}
                    />
                </Localizer>

                <div class='font-weight-lighter px-3 box-header mt-4'>
                    <i class='fa-solid fa-paperclip me-2' />
                    <Text id='sendEmail.attachments'>Attachments</Text>
                </div>
                <div class='w-100 px-3 py-2 mt-2 d-flex flex-column bg-body-secondary rounded-lg'>
                    <DragNDropFileupload
                        handleAddImage={this.handleUploadedFile}
                        apiUrl={'/api/fileupload'}
                        autoOpen={false}
                        accept='*/*'
                        text={<Text id='sendEmail.drop-files-here'>Drop files here or click to upload</Text>}
                        typeOfFile='file'
                    />
                    {uploadedFiles.length > 0 && (
                        <div class='mt-2'>
                            {uploadedFiles.map(file => (
                                <div key={file.s3Link} class='d-flex flex-row align-items-center py-1'>
                                    <i class='fa-solid fa-file me-2 text-body-secondary' />
                                    <span>{file.name}</span>
                                    <button
                                        type='button'
                                        class='btn btn-sm btn-outline-danger ms-2 rounded-pill'
                                        data-url={file.s3Link}
                                        onClick={this.removeUploadedFile}
                                    >
                                        <i class='fa-solid fa-times' />
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div class='d-flex flex-column justify-content-center mt-5'>
                    <button
                        type='button'
                        class={`btn btn-block btn-primary rounded-pill`}
                        onClick={this.sendEmail}
                        disabled={error || message}
                    >
                        <i class='fa-solid fa-paper-plane me-1' /> Send email
                        {inProgress && <>
                            <span class='spinner-border spinner-border-sm ms-2' role='status' aria-hidden='true' />
                        </>}
                    </button>

                    {error && <div class='w-100 d-flex px-3 mt-4 justify-content-center'>
                        <div class='alert alert-danger rounded-pill' role='alert'>
                            {error}
                        </div>
                    </div>}
                    {errorTmp && <div class='w-100 d-flex px-3 mt-4 justify-content-center'>
                        <div class='alert alert-danger rounded-pill' role='alert'>
                            {errorTmp}
                        </div>
                    </div>}
                    {message && <div class='w-100 d-flex px-3 mt-4 justify-content-center'>
                        <div class='alert alert-success rounded-pill' role='alert'>
                            {message}
                        </div>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default SendEmail;
